import * as C from "../constants";

import { get_reports, get_machines_addresses, get_reports_subjects, get_report,
    get_report_next, delete_report, put_report, get_reports_works
} from "utils/http";
import { parseJSON } from "utils/misc";

import { logout } from "./auth";
import { history } from "../history";

export function getReportsRequest() {
    return {
        type: C.GET_REPORTS_REQUEST
    }
}

export function getReportsFailure() {
    return {
        type: C.GET_REPORTS_FAILURE
    }
}

export function getReportsSuccess(data) {
    return {
        type: C.GET_REPORTS_SUCCESS,
        payload: data,
    }
}

export function getReportsNotAcceptedRequest() {
    return {
        type: C.GET_REPORTS_NOT_ACCEPTED_REQUEST
    }
}

export function getReportsNotAcceptedFailure() {
    return {
        type: C.GET_REPORTS_NOT_ACCEPTED_FAILURE
    }
}

export function getReportsNotAcceptedSuccess(data) {
    return {
        type: C.GET_REPORTS_NOT_ACCEPTED_SUCCESS,
        payload: data
    }
}

export function getReportsActiveRequest() {
    return {
        type: C.GET_REPORTS_ACTIVE_REQUEST
    }
}

export function getReportsActiveFailure() {
    return {
        type: C.GET_REPORTS_ACTIVE_FAILURE
    }
}

export function getReportsActiveSuccess(data) {
    return {
        type: C.GET_REPORTS_ACTIVE_SUCCESS,
        payload: data
    }
}

export function getReportsMachinesRequest() {
    return {
        type: C.GET_REPORTS_MACHINES_REQUEST
    }
}

export function getReportsMachinesFailure() {
    return {
        type: C.GET_REPORTS_MACHINES_FAILURE
    }
}

export function getReportsMachinesSuccess(data) {
    return {
        type: C.GET_REPORTS_MACHINES_SUCCESS,
        payload: data
    }
}

export function getReportsSubjectsRequest() {
    return {
        type: C.GET_REPORTS_SUBJECTS_REQUEST
    }
}

export function getReportsSubjectsFailure() {
    return {
        type: C.GET_REPORTS_SUBJECTS_FAILURE
    }
}

export function getReportsSubjectsSuccess(data) {
    return {
        type: C.GET_REPORTS_SUBJECTS_SUCCESS,
        payload: data,
    }
}

export function getReportRequest() {
    return {
        type: C.GET_REPORT_REQUEST
    }
}

export function getReportFailure() {
    return {
        type: C.GET_REPORT_FAILURE
    }
}

export function getReportSuccess(data) {
    return {
        type: C.GET_REPORT_SUCCESS,
        payload: data,
    }
}

export function getReportNextSucceess(data) {
    return {
        type: C.GET_REPORT_NEXT_SUCCESS,
        payload: data,
    }
}

export function getReportNextFailure() {
    return {
        type: C.GET_REPORT_NEXT_FAILURE
    }
}

export function editReportSuccess(data) {
    return {
        type: C.EDIT_REPORT_SUCCESS,
        payload: data,
    }
}

export function editReportFailure() {
    return {
        type: C.EDIT_REPORT_FAILURE
    }
}

export function deleteReportSuccess() {
    return {
        type: C.DELETE_REPORT_SUCCESS
    }
}

export function deleteReportFailure() {
    return {
        type: C.DELETE_REPORT_FAILURE
    }
}

export function getReportsWorksRequest() {
    return {
        type: C.GET_REPORTS_WORKS_REQUEST
    }
}

export function getReportsWorksFailure() {
    return {
        type: C.GET_REPORTS_WORKS_FAILURE
    }
}

export function getReportsWorksSuccess(data) {
    return {
        type: C.GET_REPORTS_WORKS_SUCCESS,
        payload: data,
    }
}

export function getReports(token, page, rows_per_page, from_time, to_time, order_by, desc) {
    return function (dispatch) {
        dispatch(getReportsRequest());
        return get_reports(token, page, rows_per_page, from_time, to_time, false, false, order_by, desc)
            .then(parseJSON).then(response => {
                dispatch(getReportsSuccess(response))
            }).catch(error => {
                dispatch(getReportsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReportsNotAccepted(token, page, rows_per_page) {
    return function (dispatch) {
        dispatch(getReportsNotAcceptedRequest());
        return get_reports(token, page, rows_per_page, null, null, true)
            .then(parseJSON).then(response => {
                dispatch(getReportsNotAcceptedSuccess(response))
            }).catch(error => {
                dispatch(getReportsNotAcceptedFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReportsActive(token, page, rows_per_page) {
    return function (dispatch) {
        dispatch(getReportsActiveRequest());
        return get_reports(token, page, rows_per_page, null, null, false, true)
            .then(parseJSON).then(response => {
                dispatch(getReportsActiveSuccess(response))
            }).catch(error => {
                dispatch(getReportsActiveFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReportsMachines(token) {
    return function (dispatch) {
        dispatch(getReportsMachinesRequest());
        return get_machines_addresses(token)
            .then(parseJSON).then(response => {
                dispatch(getReportsMachinesSuccess(response))
            }).catch(error => {
                dispatch(getReportsMachinesFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReportsSubjects(token) {
    return function (dispatch) {
        dispatch(getReportsSubjectsRequest());
        return get_reports_subjects(token)
            .then(parseJSON).then(response => {
                dispatch(getReportsSubjectsSuccess(response))
            }).catch(error => {
                dispatch(getReportsSubjectsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReport(token, id) {
    return function (dispatch) {
        dispatch(getReportRequest());
        return get_report(token, id)
            .then(parseJSON).then(response => {
                dispatch(getReportSuccess(response))
            }).catch(error => {
                dispatch(getReportFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReportNext(token, id) {
    return function (dispatch) {
        return get_report_next(token, id)
            .then(parseJSON).then(response => {
                dispatch(getReportNextSucceess(response))
            }).catch(error => {
                dispatch(getReportNextFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function editReport(token, report) {
    return function (dispatch) {
        return put_report(token, report)
            .then(parseJSON).then(response => {
                dispatch(editReportSuccess(response))
            }).catch(error => {
                dispatch(editReportFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function deleteReport(token, id) {
    return function (dispatch) {
        return delete_report(token, id)
            .then(parseJSON).then(response => {
                dispatch(deleteReportSuccess());
                history.replace("/reports");
            }).catch(error => {
                dispatch(deleteReportFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getReportsWorks(token) {
    return function (dispatch) {
        dispatch(getReportsWorksRequest());
        return get_reports_works(token)
            .then(parseJSON).then(response => {
                dispatch(getReportsWorksSuccess(response))
            }).catch(error => {
                dispatch(getReportsWorksFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/reports.js